<div>
  <table class="table table-striped">
    <tbody>
    <tr *ngFor="let row of rows">
      <td class="row-cell row-120">
        <div class="d-flex flex-column">
          <div>{{ row.measureCategory.internalId }}</div>
          <pt-w-measure-category-type-badge
            [type]="row.measureCategory.type"
            [typeLabel]="undefined">
          </pt-w-measure-category-type-badge>
        </div>
      </td>
      <td class="row-cell w-100">
        <div class="d-flex flex-row w-100">
          <span *ngIf="row.measureCategory.description">{{ row.measureCategory.description }}</span>
          <pt-w-help *ngIf="row.measureCategory.help" [help]='row.measureCategory.help'></pt-w-help>
        </div>
        <div class="d-flex flex-row w-100 wra-badge-container">
          <div *ngIf="row.measureCategory.normativeReference"
               container='body'
               ngbTooltip="{{row.measureCategory.normativeReference}}"
               class='badge rounded-pill badge-light wra-badge'>
            {{ row.measureCategory.normativeReference }}
          </div>
          <div *ngIf="row.measureCategory.category"
               container='body'
               ngbTooltip="{{row.measureCategory.category}}"
               class='badge rounded-pill badge-light wra-badge wra-badge-orange'>
            {{ row.measureCategory.category }}
          </div>
          <div container='body' *ngIf="row.measureCategory" [ngbPopover]='relatedThreats'
               class="wra-btn-link wra-btn-poppover">
            {{ header.relatedThreats }}
          </div>


          <ng-template #relatedThreats>
            <div class='d-flex w-100 flex-column'>
              <div class='d-flex flex-row ' *ngFor="let t of threats">
                <pt-icon
                  [ngClass]="classMeasureCategoryChecked(row, t)"
                  [key]='iconMeasureCategoryChecked(row, t)'></pt-icon>
                <div>{{ t.label }}</div>
              </div>
            </div>
          </ng-template>
        </div>
      </td>
      <td class="row-cell">
        <pt-wra-implemented-value-selector
          [selectedGlobalMeasure]="selectedGlobalMeasure"
          [editable]="editable"
          [row]="row"
          [emptyLabel]="'LABELS.NO_RESPONSE' | translate"
          [implementedValues]="implementedValues"
          (changedImplementedValue)="changedImplementedValue($event, row)">
        </pt-wra-implemented-value-selector>
      </td>
      <td class="row-cell row-120">
        <div class="wra-btn-link"
             [ngClass]="{'wra-btn-link-red': row.widgetValue?.implementedValue > 50 && row.widgetValue?.note === undefined}"
             (click)='openNote(row)'>
          {{ header.note }}
        </div>
      </td>
    </tr>
    </tbody>
  </table>
</div>

